const changeSelectedCategory = category => ({
  type: 'CHANGE_SELECTED_CATEGORY',
  category
})

const changeGroupStatus = (id, status) => ({
  type: 'CHANGE_GROUP_STATUS',
  id,
  status
})

export { changeSelectedCategory, changeGroupStatus }
